export default __webpack_public_path__ + "static/media/people_type_older_active.4e0af438.svg";